import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import {
  ExtensionsCreateGuard,
  ExtensionsGuard,
} from '../../components/Restrictors';
import { activitiesExtensionsPath } from '../../containers/Activities/routes';
import { externalStoresEnabledSelector } from '../../redux/modules/organizationGroup/selectors';
import { CreateExtensionPage } from './pages/create-extension/CreateExtensionPage';
import { ExtensionDetailPage } from './pages/extension-detail/ExtensionDetailPage';
import { ExtensionEditorPage } from './pages/extension-editor/ExtensionEditorPage';
import { ExtensionsPage } from './pages/extensions-page/ExtensionsPage';
import { ExternalStorePage } from './pages/external-store/ExternalStorePage';
import { ExtensionsStorePage } from './pages/store/ExtensionsStorePage';
import {
  extensionCodeRoute,
  extensionDetailsRoute,
  ExtensionParams,
  extensionsActivitiesPath,
  extensionsCreatePath,
  extensionsLogsPath,
  extensionsStorePath,
  externalStorePath,
  myExtensionsPath,
} from './routes';

export const ExtensionsRoutes = () => {
  const extensionDetailMatch = useRouteMatch<ExtensionParams>(
    extensionDetailsRoute
  );

  const externalStoresEnabled = useSelector(externalStoresEnabledSelector);

  return (
    <Switch>
      <Route
        exact
        path={myExtensionsPath()}
        render={() => (
          <ExtensionsGuard>
            <ExtensionsPage />
          </ExtensionsGuard>
        )}
      />
      <Route
        path={extensionsStorePath()}
        render={() => <ExtensionsStorePage />}
      />
      {externalStoresEnabled ? (
        <Route
          path={externalStorePath()}
          render={() => <ExternalStorePage />}
        />
      ) : null}
      <Route
        path={extensionsCreatePath()}
        render={() => (
          <ExtensionsCreateGuard>
            <CreateExtensionPage />
          </ExtensionsCreateGuard>
        )}
      />
      <Route
        path={extensionsLogsPath()}
        render={() => <Redirect to={extensionsActivitiesPath()} />}
      />
      <Route
        path={extensionsActivitiesPath()}
        render={({ location }) => (
          <Redirect
            to={{
              pathname: activitiesExtensionsPath(),
              state: { redirectedFromExtensions: true },
              search: location.search,
            }}
          />
        )}
      />
      {extensionDetailMatch ? (
        <Route path={extensionDetailsRoute}>
          <Switch>
            <Route
              exact
              path={extensionCodeRoute}
              render={() => (
                <ExtensionEditorPage
                  extensionId={Number(extensionDetailMatch.params.extensionId)}
                />
              )}
            />
            <Route
              path={extensionDetailsRoute}
              render={() => (
                <ExtensionDetailPage
                  detailUrl={extensionDetailMatch.url}
                  extensionId={Number(extensionDetailMatch.params.extensionId)}
                />
              )}
            />
          </Switch>
        </Route>
      ) : (
        <Redirect to={myExtensionsPath()} />
      )}
    </Switch>
  );
};
